import Container from '@/components/layout/Container';

export default function BannerGeneric({ block, position }) {
  const {
    heading,
    heading_color_picker,
    subheading,
    background_color_picker,
    _metadata
  } = block.banner_generic;

  return (
    <section
      id={_metadata.uid + '_' + position}
      data-name="banner-banner-generic"
      className={`banner-generic bg-[${background_color_picker}] py-15`}
    >
      <Container fullpage={false}>
        <div className="flex flex-col items-center justify-center px-4 sm:px-11 lg:px-0">
          <h1
            className={`h3 sm:h2 mb-5 p-2 text-center text-[${heading_color_picker}]`}
          >
            {heading}
          </h1>
          <p className="body-r sm:body-l py-2 text-center">{subheading}</p>
        </div>
      </Container>
    </section>
  );
}
